<template>
  <a-modal
    title="修改头像"
    :visible="visible"
    :maskClosable="false"
    :confirm-loading="submitLoading"
    :width="800"
    :footer="null"
    @cancel="cancelHandel"
  >
    <a-row>
      <a-col :xs="24" :md="12" :style="{ height: '350px' }">
        <vue-cropper
          ref="cropper"
          :img="options.img"
          :info="true"
          :autoCrop="options.autoCrop"
          :autoCropWidth="options.autoCropWidth"
          :autoCropHeight="options.autoCropHeight"
          :fixedBox="options.fixedBox"
          @realTime="realTime"
        >
        </vue-cropper>
      </a-col>
      <a-col :xs="24" :md="12" :style="{ height: '350px' }">
        <div class="avatar-upload-preview">
          <a-avatar :size="180" :src="previews.url" :style="previews.img" />
          <!-- <a-avatar :size="180" :src="$url + avatar" :style="previews.img" v-else /> -->
        </div>
      </a-col>
    </a-row>
    <br />
    <a-row>
      <a-col :lg="2" :md="2">
        <a-upload name="file" :beforeUpload="beforeUpload" :showUploadList="false">
          <a-button icon="upload">选择图片</a-button>
        </a-upload>
      </a-col>
      <a-col :lg="{ span: 1, offset: 2 }" :md="2">
        <a-button icon="plus" @click="changeScale(1)" />
      </a-col>
      <a-col :lg="{ span: 1, offset: 1 }" :md="2">
        <a-button icon="minus" @click="changeScale(-1)" />
      </a-col>
      <a-col :lg="{ span: 1, offset: 1 }" :md="2">
        <a-button icon="undo" @click="rotateLeft" />
      </a-col>
      <a-col :lg="{ span: 1, offset: 1 }" :md="2">
        <a-button icon="redo" @click="rotateRight" />
      </a-col>
      <a-col :lg="{ span: 2, offset: 6 }" :md="2">
        <a-button type="primary" :loading="uploading" @click="finish('blob')">保存</a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
import store from '@/store'
// import { uploadAvatar } from '@/api/system/user'
import { mapGetters } from 'vuex'
import { ossSignature, ossSigkey } from '@/api/system/user'
import COS from 'cos-js-sdk-v5'
import moment from 'moment'
export default {
  data() {
    return {
      visible: false,
      id: null,
      submitLoading: false,
      fileList: [],
      uploading: false,
      options: {
        img: '',
        autoCrop: true,
        autoCropWidth: 200,
        autoCropHeight: 200,
        fixedBox: true,
      },
      previews: {},
    }
  },
  computed: {
    // ...mapGetters(['avatar']),
  },
  methods: {
    edit(id, avatar) {
      this.visible = true
      this.id = id
      /* 获取原始头像 */
      this.imgTrick(this.$url + avatar)
    },
    // 处理跨域
    imgTrick(src) {
      const image = new Image()
      const _this = this
      image.src = src + '?timeStamp=' + Math.random()
      image.crossOrigin = 'Anonymous' // 支持跨域图片
      image.onload = function () {
        const canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        const ctx = canvas.getContext('2d')
        ctx.drawImage(image, 0, 0, image.width, image.height)
        _this.options.img = canvas.toDataURL('image/png') // 可选其他值 image/jpeg
      }
    },
    close() {
      this.id = null
      this.visible = false
    },
    cancelHandel() {
      this.close()
    },
    changeScale(num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft()
    },
    rotateRight() {
      this.$refs.cropper.rotateRight()
    },
    beforeUpload(file) {
      const reader = new FileReader()
      // 把Array Buffer转化为blob 如果是base64不需要
      // 转化为base64
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.options.img = reader.result
      }
      this.fileName = file.name
      // 转化为blob
      // reader.readAsArrayBuffer(file)

      return false
    },
    // 获取文件名称
    generateCosKey(name, ext) {
      var ymd = moment().format('YYYYMMDD')
      var ymd = moment().format('YYYYMMDD_HHmmss_')
      var r = ('000000' + Math.random() * 1000000).slice(-6)
      var cosKey = name + `/IMG_${ymd}_${r}.${ext}`
      return cosKey
    },
    camSafeUrlEncode(str) {
      return encodeURIComponent(str)
        .replace(/!/g, '%21')
        .replace(/'/g, '%27')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/\*/g, '%2A')
    },
    // 上传图片（点击上传按钮）
    finish(type) {
      const _this = this
      this.uploading = true
      const formData = new FormData()
      // 输出
      if (type === 'blob') {
        this.$refs.cropper.getCropBlob((data) => {
          console.log(data, 'datadatadata==')
          console.log(COS, 'COSCOS')
          const isLt2M = data.size / 1024 / 1024
          console.log(isLt2M, 'isLt2MisLt2MisLt2MisLt2M')
          var img = window.URL.createObjectURL(data)
          console.log(img, 'ddddmm的点点滴滴888')
          this.model = true
          this.modelSrc = img
          console.log(data, 'datadatadatadata')
          console.log(this.fileName, 'fileNamefileNamefileNamefileName')
          formData.append('file', data, this.fileName)
          var lastIndex = this.fileName.lastIndexOf('.')
          console.log('选择的图片路径fileName', lastIndex)
          var extName = lastIndex > -1 ? this.fileName.slice(lastIndex + 1) : ''
          console.log(extName, 'extNameextNameextName')
          const cosKey = this.generateCosKey(this.$cosUrl, extName)
          const fileNames = cosKey.split('/').pop()
          console.log(cosKey, 'cosKeycosKeycosKey')
          ossSignature().then((res) => {
            console.log(res, 'resresres')
            res = res.data
            const cos = new COS({
              SecretId: res.tmpSecretId,
              SecretKey: res.tmpSecretKey,
              SecurityToken: res.sessionToken, // sts服务下发的临时 SessionToken
              StartTime: res.startTime, // 建议传入服务端时间，可避免客户端时间不准导致的签名错误
              ExpiredTime: res.expiredTime, // 临时密钥过期时间
            })
            cos.putObject(
              {
                Bucket: this.$Bucket , // 对象存储桶名称
                Region: 'ap-beijing', // 地域
                Key: cosKey, // 文件路径
                Body: data, // 文件对象
                Headers: {
                  // 通过 imageMogr2 接口进行 jpg 压缩
                  'Pic-Operations': JSON.stringify({
                    is_pic_info: 1, // 返回图片信息
                    rules: [
                      {
                        fileid: fileNames, // 压缩后的文件名
                        rule: 'imageMogr2/quality/33', // 启用极智压缩
                      },
                    ],
                  }),
                },
                SliceSize:
                  1024 *
                  1024 *
                  5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
                onProgress: function (progressData) {
                },
              },
              function (err, data) {
                if (err) {
                  console.log('上传失败', err)
                } else {
                  _this.$message.success('上传成功')
                  _this.$emit('ok', cosKey)
                  _this.visible = false
                }
              }
            )
          })
        })
      } else {
        this.$refs.cropper.getCropData((data) => {
          this.model = true
          this.modelSrc = data
        })
      }
      this.uploading = false
    },
    okHandel() {
      const vm = this

      vm.submitLoading = true
      setTimeout(() => {
        vm.submitLoading = false
        vm.close()
        vm.$message.success('上传头像成功')
      }, 2000)
    },

    realTime(data) {
      console.log(data)
      this.previews = data
    },
  },
}
</script>

<style lang="less" scoped>
.avatar-upload-preview {
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
  width: 180px;
  height: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
